export default __webpack_public_path__ + "static/70-e27eb56ae404507c8bf30c62c7d45cf9.png";